<template>
  <div class="overlay-full overlay-ongoing-course" :style="{ display: show ? 'block' : '' }">
    <div class="overlay-content">
      <p class="title">
        Your course "<span class="ongoing-course-name">{{ courseName }}</span>" is taking place right now.
      </p>
      <p>Would you like to attend?</p>
      <div>
        <a :href="courseAttend" :class="`btn btn-primary ongoing-course-attend ${isDisabled}`" data-answer="yes">
          Yes, please
        </a>
        <a href="#" :class="`btn btn-info ongoing-course-reschedule ${isDisabled}`" data-answer="maybe" @click="rescheduleCourse">
          Reschedule
        </a>
        <a href="#" :class="`btn btn-light ongoing-course-reject ${isDisabled}`" data-answer="no" @click="reject">
          Not for now
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import CustomButton from "../Button.vue"

export default {
  name: "OverlayCourseOngoing",
  components: {
    CustomButton
  },
  data() {
    return {
      show: false,
      courseName: '',
      courseAttend: '',
      isDisabled: ''
    }
  },
  mounted() {
    axios
      .get(window.courseUrl.ongoingChecker)
      .then(response => {
        const data = response.data;

        if (data) {
          this.show = true
          this.courseName = data.name
          this.courseAttend = window.courseUrl.preview.replace(':id', data.id)
        }
      })
      .catch(error => {
        new Noty({
          type: "warning",
          text: 'Something happened',
        }).show();
      });
  },
  methods: {
    rescheduleCourse() {
      this.isDisabled = 'disabled';

      const modal = $('.modal-course-reminder-list');

      if (!modal.data('bs.modal')?._isShown) {
        modal.modal('show').find('.modal-content').load(window.courseUrl.reminderList);
      }

      modal.on('shown.bs.modal', () => {
        this.show = false;
        this.isDisabled = '';
      });
    },
    reject() {
      this.show = false
    }
  }
}
</script>
